import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITrainingTemplateResource } from "../types";

export interface ITrainingTemplateDeleteMutationParameters {
    trainingTemplate: RelationalValue<ITrainingTemplateResource>;
}

export type ITrainingTemplateDeleteMutationResult = void;

export const trainingTemplateDeleteMutation: IApiMutationFunction<ITrainingTemplateDeleteMutationParameters> = ({
    trainingTemplate,
}) => {
    return {
        method: "DELETE",
        url: `/training_templates/${mapRelationalValue(trainingTemplate)}`,
    };
};

export const useTrainingTemplateDeleteMutation = createApiMutationHook<
    ITrainingTemplateDeleteMutationParameters,
    ITrainingTemplateDeleteMutationResult
>(trainingTemplateDeleteMutation);
